<template>
    <RouterLink
        :to="{ name: this.item.model+'.view', params: { id: item.id, slug: item.slug } }"
        class="p-3 rounded flex flex-col gap-3 justify-between text-white h-[370px] w-full relative overflow-hidden"
    >
        <div class="bg-black absolute top-0 left-0 h-full w-full z-[-1]">
            <img
                :src="item.cover && item.cover.cached_url"
                class="object-cover object-center h-full w-full opacity-80"
                alt=""
            >
        </div>

        <div class="flex flex-col gap-20">
            <div :style="itemHasType ? '' : 'height: 18px'">
                <div v-if="itemHasType" class="border border-white rounded-md text-xs h-fit px-1 w-fit">
                    {{ item.types[0].name }}
                </div>
            </div>

            <div class="text-4xl font-vectrex line-clamp-3">
                <p class="py-2">{{ itemName }}</p>
            </div>
        </div>

        <div class="text-sm">
            <span v-if="item.finishing_date">{{ formatDate(item.finishing_date, "DD.MM.YYYY") }}</span>
        </div>
    </RouterLink>
</template>

<script>
import moment from "moment";

export default {
    name: 'MoleculeItemCard',
    props: {
        item: Object,
    },
    methods: {
        formatDate(dateString, format) {
            return moment(dateString).format(format);
        },
    },

    computed: {
        isTypeEvent() {
            return this.item.model === 'event';
        },

        itemName() {
            return this.isTypeEvent ? this.item.name : this.item.title;
        },

        itemHasType() {
            return this.item.types.length && this.item.types[0].name
        }
    }
};
</script>
